<template>
	<section>
		<div style="width: 100%">
			<div class="columns is-multiline is-mobile mt-3 is-variable is-2">
				<div
					v-if="shouldQuantityPickerBeShown"
					class="column is-narrow w40-mobile">
					<div class="mr-2 is-inline-block">
						<div
							class="field has-addons has-addons-centered"
							style="border: solid #ccc 1px; border-radius: 5px">
							<p
								class="control"
								style="border-right: solid #ccc 1px">
								<a
									@click="decrementQuantity"
									class="button is-medium is-white h2_5-mobile"
									:class="{
										'px-3': !this.isMobile,
										'px-3': this.isMobile,
									}"
									style="color: #777"
									><i class="fas fas fa-minus"></i>
								</a>
							</p>
							<p class="control">
								<input
									@change="updateQuantity"
									v-model="$data.quantity"
									min="1"
									value="1"
									:max="availability"
									class="input is-medium quantity-input has-text-centered px-0-mobile h2_5-mobile"
									type="number"
									placeholder="##"
									style="
										max-width: 1in;
										border-top: none;
										border-bottom: none;
										color: #555;
									"
									:style="{
										width: this.isMobile ? '3rem' : '4rem',
									}" />
							</p>
							<p
								class="control"
								style="border-left: solid #ccc 1px">
								<a
									@click="incrementQuantity"
									class="button is-medium is-white h2_5-mobile"
									:class="{
										'px-3': !this.isMobile,
										'px-3': this.isMobile,
									}"
									style="color: #777"
									><i class="fas fa-plus"></i>
								</a>
							</p>
						</div>
					</div>
				</div>
				<div
					class="column is-narrow"
					:class="{
						'w60-mobile': isQuantityPickerVisible,
						'w100-mobile': !isQuantityPickerVisible,
					}">
					<button
						@click="addToCart"
						ref="addToCartButton"
						class="button is-medium is-info is-size-5-mobile w100-mobile">
						<i class="fa-solid fa-cart-shopping"></i>&nbsp;Add to Cart
					</button>
				</div>
				<div class="column is-narrow w100-mobile pt-0-mobile">
					<button
						@click="confirmPurchase"
						class="button is-medium is-success w100-mobile is-size-4-mobile">
						<i class="fa-solid fa-basket-shopping"></i>&nbsp;Buy Now
					</button>
				</div>
			</div>
		</div>

		<hr class="product-divider" />

		<div class="columns is-multiline p-3 width-100">
			<div class="column has-text-centered-touch m-0 p-0">
				<div class="columns is-size-6 m-0">
					<div
						v-show="model != 'Single-Payment'"
						class="column p-0">
						<span class="mt-3"
							><span class="has-text-weight-bold">Payment Type:</span
							>&nbsp;
							<span
								class="has-text-success"
								v-html="model"></span
						></span>
					</div>
					<div class="column p-0">
						<span class="mt-3"
							><span class="has-text-weight-bold">Delivery:</span>&nbsp;
							<!-- TODO: IF user is logged in allow use of a Primary delivery price e.g Delivery: $600 (calculated using saved delivery method [DELIVERY METHOD NAME]. Change delivery method at checkout if desired. But something shorter than what is said in this todo of course.) -->
							<span class="has-text-success"
								>Calculated at checkout</span
							></span
						>
					</div>
				</div>
			</div>
		</div>

		<quick-purchase
			ref="quickPurchase"
			:endpoint="endpoint"
			:product_prop="[
				{
					id: this.product_id_prop,
					images: [this.image_link_prop],
					name: this.name_prop,
					price: this.price_prop,
					currency: this.currency_prop,
					choices: this.$store.getters.choices,
					quantity: this.quantity,
				},
			]"></quick-purchase>
		<purchase-modal
			ref="purchaseModal"
			:endpoint="endpoint"
			:product_prop="[
				{
					id: this.product_id_prop,
					images: [this.image_link_prop],
					name: this.name_prop,
					price: this.price_prop,
					currency: this.currency_prop,
					choices: this.$store.getters.choices,
					quantity: this.quantity,
				},
			]"
			:sign_up_link_prop="sign_up_link_prop"
			:login_link_prop="login_link_prop"></purchase-modal>
	</section>
</template>
<style scoped>
	.no-scrollbar::-webkit-scrollbar {
		display: none;
	}

	/* Hide scrollbar for IE, Edge and Firefox */
	.no-scrollbar {
		-ms-overflow-style: none; /* IE and Edge */
		scrollbar-width: none; /* Firefox */
	}

	.width-100 {
		width: 100%;
	}

	/* Chrome, Safari, Edge, Opera */
	.quantity-input::-webkit-outer-spin-button,
	.quantity-input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	.quantity-input[type="number"] {
		-moz-appearance: textfield;
	}
</style>
<script type="text/javascript">
	import axios from "axios";
	import Vue from "vue";
	import Buefy from "buefy";
	import PurchaseModal from "../PurchaseInterfaces/PurchaseModal.vue";
	import QuickPurchase from "../PurchaseInterfaces/QuickPurchase.vue";
	import AddToWishlistButton from "../WishlistComponents/AddToWishlistButton.vue";

	Vue.use(Buefy);

	// Setting up input masking should come later
	export default {
		props: [
			"add_to_cart_json_link",
			"model_prop",
			"price_prop",
			"currency_prop",
			"name_prop",
			"product_id_prop",
			"image_link_prop",
			"sign_up_link_prop",
			"login_link_prop",
			"endpoint",
			"wishlist_link_prop",
			"availability_prop",
		],
		components: {
			PurchaseModal,
			QuickPurchase,
			AddToWishlistButton,
		},
		data() {
			return {
				wishlist: false,
				quantity: 1,
			};
		},
		computed: {
			model() {
				return this.$props.model_prop;
			},
			price() {
				return this.$props.price_prop;
			},
			name() {
				return this.$props.name_prop;
			},
			logged_in() {
				return JSON.parse(window.sessionStorage.getItem("logged_in")).value;
			},
			computedQuantity() {
				return parseInt(this.$data.quantity);
			},
			availability() {
				return parseInt(this.availability_prop);
			},
			shouldQuantityPickerBeShown() {
				return this.availability > 1;
			},
			isQuantityPickerVisible() {
				return this.shouldQuantityPickerBeShown;
			},
			isMobile() {
				return window.screen.width < 768;
			},
		},
		mounted() {
			this.updateQuantity();
		},
		methods: {
			addToWishList() {
				// axios.get()
				//     .then (function(response){})
				//     .catch(function(response){})
				//     .then (function(response){})
				this.wishlist = !this.wishlist;
				// window.notifier.show({
				// 	type: "warning",
				// 	text: `${this.name} Added to WishList`,
				// 	duration: 4000,
				// });
			},
			addToCart() {
				let cart = [];
				let _this = this;
				this.$refs.addToCartButton.classList.add("is-loading");
				//If there is something in your cart already then fetch it.
				if (window.localStorage.getItem("cart")) {
					cart = JSON.parse(window.localStorage.getItem("cart"));
				}
				axios
					.get(this.add_to_cart_json_link)
					.then(
						function (response) {
							let p = response.data;
							let product = {
								id: _this.product_id_prop,
								name: p.name,
								availability: p.availability,
								quantity: p.quantity,
								shop: p.shop,
								pricing: {
									model: p.pricing.model,
									current: p.pricing.current,
									currency: p.pricing.currency,
								},
								images: p.images,
								choices: _this.$store.getters.choices,
								link: p.link,
							};
							cart.push(product);
							console.log(product);
							this.$buefy.notification.open({
								message: `Successfully added "${product.name}" to Cart!`,
								type: "is-info",
								position: "is-top",
								pauseOnHover: true,
								progressBar: true,
								duration: 4000,
							});
						}.bind(this)
					)
					.catch(function (response) {
						this.$buefy.notification.open({
							message: `Failed to add "${product.name}" to Cart!`,
							type: "is-warning",
							position: "is-top",
							pauseOnHover: true,
							progressBar: true,
							duration: 6000,
						});
					})
					.then(function (response) {
						window.localStorage.setItem("cart", JSON.stringify(cart));
						// Delay for UX, so the loader doesn't flash for the user
						setTimeout(() => {
							_this.$refs.addToCartButton.classList.remove("is-loading");
						}, 400);
					});
			},
			confirmPurchase() {
				this.updateQuantity();
				//window.sessionStorage.setItem('logged_in', true | false) is in the main & dash view to tell if a user is logged in or not
				if (JSON.parse(window.sessionStorage.getItem("logged_in")).value) {
					this.$refs.quickPurchase.launchModal();
				} else {
					// This toggles the modal that appears when an unregistered user clicks "Buy Now"
					this.$refs.purchaseModal.launchModal();
				}
			},
			decrementQuantity() {
				if (typeof this.$data.quantity != "number") {
					this.$data.quantity = 1;
				}
				if (this.$data.quantity <= 0) {
					this.$data.quantity = 0;
					return alert(`You cannot go below zero`);
				}
				this.$data.quantity--;
				this.updateQuantity();
			},
			incrementQuantity() {
				if (typeof this.$data.quantity != "number") {
					this.$data.quantity = 1;
				}
				if (this.$data.quantity >= this.availability) {
					this.$data.quantity = this.availability;
					return alert(
						`There are only ${this.availability} of this product available`
					);
				}
				this.$data.quantity++;
				this.updateQuantity();
			},
			updateQuantity() {
				//Needed in case the quantity is read as a text instead of a number
				this.$data.quantity = parseInt(this.$data.quantity);
				if (this.$data.quantity <= 0) {
					this.$data.quantity = 0;
					return;
				}
				if (this.$data.quantity >= this.availability) {
					this.$data.quantity = this.availability;
					return;
				}

				this.$store.dispatch("set_quantity", this.computedQuantity);
			},
		},
	};
</script>
